import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ProcessSection from './components/ProcessSection';
import CTASection from './components/CTASection';
import ProgrammingServices from './components/ProgrammingServices';
import ToolsSection, { type Tool } from '../../components/feature/ToolsSection';

const programmingTools: Tool[] = [
  {
    name: 'Lutron Designer',
    description: 'The definitive software for designing and programming Lutron\'s high-end HomeWorks and RadioRA systems.',
    icon: 'ri-lightbulb-flash-line',
    color: 'from-orange-500 to-amber-600'
  },
  {
    name: 'Savant Blueprint',
    description: 'Powerful configuration environment for building complex Savant automation and control ecosystems.',
    icon: 'ri-layout-masonry-line',
    color: 'from-blue-600 to-indigo-700'
  },
  {
    name: 'Savant Pro App',
    description: 'The award-winning interface that provides homeowners with complete control of their environment.',
    icon: 'ri-smartphone-line',
    color: 'from-violet-500 to-purple-600'
  }
];

export default function ProgrammingPage() {
  return (
    <div className="min-h-screen bg-white dark:bg-slate-900 transition-colors duration-300">
      <Header />
      <main>
        <ProgrammingServices />
        <ToolsSection
          title="Programming Environment"
          description="We utilize the official manufacturer software to ensure your control system is programmed according to industry best practices and standards."
          tools={programmingTools}
        />
        <ProcessSection serviceType="takeoff" /> {/* Reusing takeoff process as it's generic enough or matches the workflow */}
        <CTASection serviceType="takeoff" />
      </main>
      <Footer />
    </div>
  );
}
